/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as InfoIcon } from '../../../assets/images/info_24px.svg';
import { t } from '../../../providers';
import AuthContainer from '../components/AuthContainer';

const useStyles = makeStyles((theme) => ({
    clearButton: {
        backgroundColor: theme.palette.text.mainGreen,
        color: theme.palette.text.primary,
        height: '2rem',
        border: 'none',
        margin: 'unset',
        borderRadius: '3px',
        lineHeight: '12px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D !important',
            borderRadius: '3px',
        },
        '&:hover': {
            backgroundColor: theme.palette.text.mainGreen,
        },
        '@media (max-width:600px)': {
            width: '100%',
        },
    },
}));

const GeneralErrorPage = () => {
    const classes = useStyles();
    const infoIcon = <InfoIcon aria-hidden="true" focusable="false" />;
    let renderBody = t('error.page.message');
    let title = t('error.page.title');

    return (
        <AuthContainer preTitle={infoIcon} title={title}>
            <div>
                {renderBody}
                <br />
                <br />
                <Button
                    disableFocusRipple
                    className={classes.clearButton}
                    variant="contained"
                    onClick={() => {
                        window.location.replace('https://inpi.justica.gov.pt/');
                    }}>
                    {t('error.page.button.text')}
                </Button>
            </div>
        </AuthContainer>
    );
};

export default GeneralErrorPage;
